import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

// Confirm-save guard shown when an admin (impersonating a user) saves a profile,
// to minimise the risk of accidental changes (STU-17).
const ConfirmSaveDialog = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose} aria-labelledby="confirm-save-title">
    <DialogTitle id="confirm-save-title">
      <FormattedMessage id="profile.confirmSave.title" defaultMessage="Save changes?" />
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        <FormattedMessage
          id="profile.confirmSave.body"
          defaultMessage="Save the changes to this user's profile?"
        />
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        <FormattedMessage id="profile.confirmSave.cancel" defaultMessage="Cancel" />
      </Button>
      <Button onClick={onConfirm} color="primary" variant="contained" autoFocus>
        <FormattedMessage id="profile.confirmSave.confirm" defaultMessage="Save" />
      </Button>
    </DialogActions>
  </Dialog>
);

ConfirmSaveDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmSaveDialog;
